import { useState } from "react";
import { MessageCircleHeart, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const MAX = 80;

export const GreetingEditor = ({ onSaved }) => {
  const { user, setUser } = useAuth();
  const [text, setText] = useState(user?.supporter_greeting || "");
  const [busy, setBusy] = useState(false);
  const dirty = text.trim() !== (user?.supporter_greeting || "");
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/supporters/greeting", { text });
      setUser({ ...user, supporter_greeting: data.greeting || null });
      setText(data.greeting || "");
      onSaved?.(data.greeting);
      toast.success(data.greeting ? "Dein Gruß ist jetzt in der Liste zu sehen 💖" : "Gruß entfernt");
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="sp-post sp-glow rounded-3xl p-4 sm:p-5 space-y-2" data-testid="greeting-editor">
      <p className="font-bold flex items-center gap-2"><MessageCircleHeart className="w-5 h-5 text-amber-600" /> Dein Gruß an die Community</p>
      <div className="flex gap-2">
        <input value={text} maxLength={MAX} onChange={(e) => setText(e.target.value)} placeholder="z. B. Danke, dass es euch gibt! 💖" data-testid="greeting-input"
          className="flex-1 min-w-0 h-11 px-4 rounded-full border border-amber-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-amber-300" />
        <button type="submit" disabled={busy || !dirty} data-testid="greeting-save" className="h-11 px-5 rounded-full vip-gold-metal text-sm font-extrabold inline-flex items-center gap-1.5 disabled:opacity-50 active:scale-95 transition-transform"><Check className="w-4 h-4" /> Speichern</button>
      </div>
      <p className="text-[11px] text-slate-500 flex justify-between"><span>Erscheint sofort auf deiner Karte · wird automatisch geprüft</span><span data-testid="greeting-count">{text.length}/{MAX}</span></p>
    </form>
  );
};

export const GreetingBubble = ({ text, testId }) => text ? (
  <p data-testid={testId} className="relative mt-1.5 inline-block max-w-full rounded-2xl rounded-tl-sm bg-white/80 border border-amber-200/70 px-3 py-1.5 text-[13px] italic text-[#7a4f12] break-words">„{text}“</p>
) : null;
